/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useState} from 'react'
import {Dispatch} from 'redux'
import {Modal} from 'react-bootstrap'
import './dialog.scss'
import {CustomOtpInput} from '../../app/modules/auth/components/otpinput/CustomOtpInput'
import {
  formattedPhoneNumber,
  handleNotificationWithToastify,
  maskEmail,
  maskPhoneNumber,
  validateEmail,
  validatePhoneNumber,
} from '../../app/services/Functional'
import {ResendOTP} from '../../app/modules/auth/components/resendotp/ResendOtp'
import PhoneInput from 'react-phone-input-2'
import {useNavigate} from 'react-router-dom'
import * as auth_actions from '../../setup/redux/auth/actions'
import {shallowEqual, useDispatch, useSelector} from 'react-redux'
import {RootState} from '../../setup'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'
import FAIcon from '../helpers/components/FAIcon'
import {faEnvelope} from '@fortawesome/free-solid-svg-icons'

interface Payload {
  user_id?: number
  mobile_no?: string
  email?: string
  mode: 'mobile' | 'email'
}

const FieldEditDialog: FC<{
  isOpenDialog: boolean
  mode: string
  handleClose: () => void
  handleverifiedOTP: () => void
  onHideDialog?: () => void
  stepStartingNumber: number
  newEmail?: string
  newPhoneNumber?: string
  newCountryCode?: string
  signUpResendOTPPayload?: any
  signUpVerifyOTPPayload?: any
}> = ({
  isOpenDialog,
  mode,
  handleClose,
  handleverifiedOTP,
  onHideDialog,
  stepStartingNumber,
  newPhoneNumber,
  newCountryCode,
  newEmail,
  signUpResendOTPPayload,
  signUpVerifyOTPPayload,
}) => {
  const {actionsLoading, user}: any = useSelector<RootState>(
    (state) => ({
      actionsLoading: state.common.actionsLoading,
      user: state.auth.user,
    }),
    shallowEqual
  )

  const dispatch: Dispatch<any> = useDispatch()
  let navigate = useNavigate()
  const isMobileMode = mode === 'mobile'
  const [step, setStep] = useState(stepStartingNumber)
  const [changedEmail, setChangedEmail] = useState(() => {
    return stepStartingNumber === 1 && newEmail ? newEmail : ''
  })
  const [changedCountryCode, setChangedCountryCode] = useState(() => {
    return stepStartingNumber === 1 && newCountryCode ? newCountryCode : ''
  })
  const [changedPhoneNumber, setChangedPhoneNumber] = useState(() => {
    return stepStartingNumber === 1 && newPhoneNumber ? newPhoneNumber : ''
  })
  const [otp, setOtp] = useState('')
  const [hasErrors, setHasErrors] = useState<boolean>(false)

  const handleEmailChange = (event: any) => {
    setChangedEmail(event.target.value)
  }
  const handleOTPChange = (otp: string) => {
    setOtp(otp)
  }

  const handleGenerateOTP = async () => {
    let values
    if (isMobileMode) {
      values = {
        mobile_no: `+${changedCountryCode + changedPhoneNumber}`,
        mode: 'mobile',
        user_id: user?.id,
      }
    } else {
      values = {
        email: changedEmail,
        mode: 'email',
        user_id: user?.id,
      }
    }
    let response: any = await dispatch(auth_actions.handleOTPMode(values))
    if (!response.success && response.code === 401) {
      navigate('/error/auth')
    } else if (!response.data.success) {
      handleNotificationWithToastify(response.data)
    } else if (response.status === 200 || response.status === 201) {
      setStep(1)
      handleNotificationWithToastify(response.data)
    } else {
      handleNotificationWithToastify(response.data)
    }
  }

  const handleOTPSubmit = async () => {
    if (otp.length === 6) {
      let response: any
      if (stepStartingNumber === 1) {
        response = await dispatch(
          auth_actions.handleVerifyOTP({
            ...signUpVerifyOTPPayload,
            otp: otp,
          })
        )
      } else {
        response = await dispatch(
          auth_actions.verifyOTP({
            id: user?.id,
            otp: otp,
            [isMobileMode ? 'new_mobile_no' : 'new_email']: isMobileMode
              ? changedPhoneNumber
              : changedEmail,
            ...(isMobileMode && {new_country_code: changedCountryCode}),
          })
        )
      }
      if (response?.success) {
        setHasErrors(false)
        localStorage.setItem('otpRemainingTime', '60')
        localStorage.setItem('otpResendCount', '0')
        localStorage.setItem('otpMaxResendCount', '3')
        handleverifiedOTP()
        setStep(2)
        setTimeout(() => {
          handleClose()
        }, 5000)
      } else {
        setHasErrors(true)
        handleNotificationWithToastify(response)
        setTimeout(() => {
          setHasErrors(false)
          setOtp('')
        }, 5000)
      }
    }
  }

  let payload: Payload

  if (isMobileMode) {
    payload = {
      mobile_no: formattedPhoneNumber(changedCountryCode, changedPhoneNumber),
      mode: 'mobile',
      user_id: user?.id,
    }
  } else {
    payload = {
      email: changedEmail,
      mode: 'email',
      user_id: user?.id,
    }
  }

  return (
    <Modal
      show={isOpenDialog}
      onHide={stepStartingNumber === 1 ? onHideDialog : handleClose}
      className='custom-dialog'
      size='lg'
      centered
      tabIndex={0}
      backdrop='static'
    >
      <Modal.Header className='border-0 pb-0' closeButton></Modal.Header>
      <Modal.Body className='pb-12 pt-0'>
        <Modal.Title className='fs-1 text-center custom-dialog-title pb-6'>
          {stepStartingNumber === 0 ? 'Change' : 'Verify'} {isMobileMode ? 'Phone Number' : 'Email'}
        </Modal.Title>
        {step === 0 && (
          <div className='custom-dialog-container pt-6 d-flex flex-column justify-content-center align-items-center gap-6'>
            <div className='custom-dialog-sub-header'>
              Provide your new {isMobileMode ? 'phone number' : 'email'} that you want to change.
            </div>
            {isMobileMode ? (
              <div className='m-0 phone-field form-group custom-dialog-field'>
                <PhoneInput
                  buttonClass='flag_dropdown'
                  dropdownStyle={{backgroundColor: 'none'}}
                  enableSearch={true}
                  disableSearchIcon={true}
                  searchStyle={{width: '90%', margin: '0'}}
                  countryCodeEditable={false}
                  country='gr'
                  value={''}
                  inputProps={{
                    name: 'phone',
                    id: 'phone',
                    required: true,
                  }}
                  onChange={(phone: any, data: any) => {
                    setChangedCountryCode(data.dialCode)
                    setChangedPhoneNumber(phone.slice(data.dialCode.length))
                  }}
                />
              </div>
            ) : (
              <div className='form-group m-0 custom-dialog-field'>
                <input
                  type='text'
                  tabIndex={1}
                  placeholder='New Email ID'
                  autoComplete='off'
                  className='form-control dialog_input'
                  value={changedEmail}
                  onChange={handleEmailChange}
                />
                <FAIcon
                  icon={faEnvelope}
                  className='custom-dialog-input-icon'
                  defaultClassnameApply={false}
                />
              </div>
            )}
            <button
              type='submit'
              disabled={
                isMobileMode
                  ? validatePhoneNumber(changedPhoneNumber, changedCountryCode)
                  : validateEmail(changedEmail) || actionsLoading
              }
              tabIndex={1}
              onClick={handleGenerateOTP}
              className={`btn btn-primary btn-pill w-100 dialog-submit-button`}
            >
              Generate OTP
              <img
                className='ms-3'
                src={'/media/icons/duotune/general/Arrow - Right.svg'}
                alt='->'
              />
            </button>
          </div>
        )}
        {step === 1 && (
          <div className='custom-dialog-container pt-6 d-flex flex-column justify-content-center align-items-center gap-6'>
            <div className='otp_sub_header dialog-otp-sub-header'>
              <div className=''>
                Enter the 6-digit code sent to
              </div>
              <OverlayTrigger
                key='show'
                placement='top'
                overlay={
                  <Tooltip id='show'>
                    {isMobileMode
                      ? maskPhoneNumber(changedPhoneNumber, changedCountryCode)
                      : maskEmail(changedEmail)}
                  </Tooltip>
                }
              >
                <span className='mask-text'>
                  {' '}
                  {isMobileMode
                    ? maskPhoneNumber(changedPhoneNumber, changedCountryCode)
                    : maskEmail(changedEmail)}
                </span>
              </OverlayTrigger>
            </div>
            <CustomOtpInput
              label='otp'
              otp={otp}
              error={hasErrors}
              handleOTPChange={handleOTPChange}
              className='dialog-otp-input'
              separatorClassName='dialog-otp-separator'
            />
            <ResendOTP
              className='dialog-resend-otp'
              APICalled={
                stepStartingNumber === 1
                  ? auth_actions.resendOTP(signUpResendOTPPayload)
                  : auth_actions.handleOTPMode(payload)
              }
              showBackBtn={false}
            />
            <button
              type='submit'
              disabled={otp.length < 6 || actionsLoading}
              tabIndex={1}
              onClick={handleOTPSubmit}
              className={`btn btn-primary btn-pill w-100 dialog-submit-button`}
            >
              Verify
              <img
                className='ms-3'
                src={'/media/icons/duotune/general/Arrow - Right.svg'}
                alt='->'
              />
            </button>
          </div>
        )}
        {step === 2 && (
          <div className='custom-dialog-container pt-6 d-flex flex-column justify-content-center align-items-center gap-6'>
            <img className='verified' src={'/media/verified.gif'} alt='Verified' />
            <div className='custom-dialog-sub-header'>
              Your {isMobileMode ? 'Phone Number' : 'Email ID'} Change Successfully !
            </div>
          </div>
        )}
      </Modal.Body>
    </Modal>
  )
}

export {FieldEditDialog}
